import { useTranslation } from '../../hooks/useNavConfig';
import styled from 'foundations-theming-specialty/utils';
import TrackedButton from '../TrackedButton';
import { Checkbox } from '../../nav-ui-components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEXTAREA_WORDS_LIMIT = 1500;
const TEXTAREA_ROW_LIMIT = 5;
const Flex = styled.div.withConfig({
  displayName: "FeedbackStep__Flex",
  componentId: "sc-68vy5c-0"
})(["display:flex;width:100%;flex-direction:column;"]);
const StyledCheckboxContainer = styled.div.withConfig({
  displayName: "FeedbackStep__StyledCheckboxContainer",
  componentId: "sc-68vy5c-1"
})(({
  theme
}) => {
  return {
    padding: `${theme.space['400']} 0`
  };
});
const CharacterCounter = styled.p.withConfig({
  displayName: "FeedbackStep__CharacterCounter",
  componentId: "sc-68vy5c-2"
})(({
  theme,
  $disabled
}) => {
  const color = $disabled ? theme.color['text-alert-default'] : theme.color['text-core-subtle'];
  return Object.assign({
    textAlign: 'right',
    margin: 0,
    marginTop: theme.space['200'],
    color
  }, theme.typography['detail-100']);
});
const Textarea = styled.textarea.withConfig({
  displayName: "FeedbackStep__Textarea",
  componentId: "sc-68vy5c-3"
})(({
  theme,
  $disabled
}) => {
  return Object.assign({
    width: '100%',
    background: theme.color['fill-surface-raised'],
    border: `${theme.borderWidth['200']} solid ${theme.color['border-core-default']}`,
    borderRadius: theme.borderRadius['200'],
    resize: 'none',
    hyphens: 'none',
    overflow: 'auto'
  }, theme.typography['body-100'], {
    margin: 0,
    transition: 'all 150ms ease-out 0s',
    padding: theme.space['200'],
    '&:focus': {
      borderColor: theme.color['border-interactive-default'],
      outline: '0',
      boxShadow: theme.boxShadow['100']
    },
    borderColor: $disabled ? theme.color['border-alert-default'] : 'inherit'
  });
});
const StyledSubmitButton = styled(TrackedButton)(({
  theme,
  $disabled
}) => {
  return Object.assign({
    alignSelf: 'center',
    borderRadius: theme.borderRadius['200'],
    border: 'none',
    textAlign: 'center',
    transition: 'all 0.15s ease-out',
    overflow: 'hidden',
    verticalAlign: 'middle'
  }, theme.typography['body-100'], {
    padding: `${theme.space['200']} ${theme.space['400']}`,
    margin: 0,
    '&:hover': {
      background: theme.color['fill-primary-hover']
    },
    background: $disabled ? `${theme.color['fill-primary-disabled']} !important` : theme.color['fill-primary-default'],
    color: $disabled ? `${theme.color['text-primary-disabled']} !important` : theme.color['text-core-on-fill-default'],
    cursor: $disabled ? 'not-allowed' : 'inherit'
  });
});
export const FeedbackStep = ({
  setFeedback,
  feedback,
  setContactConsent,
  contactConsent,
  incrementSurveyStep,
  consentTextKey
}) => {
  const {
    t
  } = useTranslation();
  const disabled = TEXTAREA_WORDS_LIMIT - feedback.length < 0;
  const onClick = () => {
    if (disabled) return;
    incrementSurveyStep();
  };
  const onChange = event => {
    setFeedback(event.currentTarget.value);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx(Textarea, {
      placeholder: t('nav.feedbackModal.textarea'),
      rows: TEXTAREA_ROW_LIMIT,
      value: feedback,
      onChange: onChange,
      $disabled: disabled
    }), /*#__PURE__*/_jsx(CharacterCounter, {
      "aria-live": "polite",
      $disabled: disabled,
      children: TEXTAREA_WORDS_LIMIT - feedback.length
    }), /*#__PURE__*/_jsx(StyledCheckboxContainer, {
      children: /*#__PURE__*/_jsx(Checkbox, {
        id: "hs-nav-feedback-contact",
        checked: contactConsent,
        onChange: ({
          currentTarget
        }) => {
          setContactConsent(currentTarget.checked);
        },
        children: t(consentTextKey)
      })
    }), /*#__PURE__*/_jsx(StyledSubmitButton, {
      onClick: onClick,
      "aria-disabled": disabled,
      $disabled: disabled,
      children: t('nav.feedbackModal.submitButton')
    })]
  });
};